var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0926 12.5372L11.9999 2.45703L4.90955 12.5338L12.0109 14.9229L19.0926 12.5372Z",
    fill: "#D2DCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0926 12.5372L11.9999 2.45703V14.9192L12.0109 14.9229L19.0926 12.5372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4947 21.5444H2.50505L0.470459 11.9043L11.9999 14.2296L23.5293 11.9043L21.4947 21.5444Z",
    fill: "#D2DCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470459 11.9043L2.50505 21.5444H2.54815L11.9999 14.2296L0.470459 11.9043Z",
    fill: "#93B2F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.2305V21.5453H21.4741L11.9998 14.2305Z",
    fill: "#93B2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4947 21.5444H2.50505L0.470459 11.9043L11.9999 14.2296L23.5293 11.9043L21.4947 21.5444Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0926 12.5372L11.9999 2.45703L4.90955 12.5338",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon1);
export default __webpack_public_path__ + "static/media/assistant-icon-1.711b3278b447905585589285b252b9d7.svg";
export { ForwardRef as ReactComponent };